<template>
  <div id="header">
    <div class="header">
      <div class="header-wrap">
        <div class="main-logo" @click="gotoPage('/')" />
        <div class="spacer" />
        <ul>
          <li :class="{ active: intro && !service }" @click="gotoPage('/intro')">
            회사소개
            <div class="border"></div>
          </li>
          <li :class="{ active: !intro && service }" @click="gotoPage('/service')">
            서비스
            <div class="border"></div>
          </li>
          <li @click="gotoPage('https://www.carsuri.co.kr/contact?tab=runoil', true)">
            제휴문의
            <div class="border"></div>
          </li>
        </ul>
        <div class="icon_menu" v-if="!isMenu" @click="menuClick()"></div>
        <div class="close_menu" v-else @click="menuClick()"></div>
      </div>
    </div>
    <div class="mobile_menu" :class="{ active: isMenu }">
      <ul>
        <li @click="gotoPage('/')">홈</li>
        <li @click="gotoPage('/intro')">회사소개</li>
        <li @click="gotoPage('/service')">서비스</li>
        <li @click="gotoPage('https://www.carsuri.co.kr/contact?tab=runoil', true)">제휴문의</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      intro: false,
      service: false,
      isMenu: false
    }
  },
  methods: {
    menuClick() {
      if (this.isMenu) {
        this.isMenu = false
        document.body.style = 'overflow : auto'
      } else {
        this.isMenu = true
        document.body.style = 'overflow : hidden'
      }
    },
    gotoPage(path, isOpen) {
      if (isOpen) {
        window.open(path)
      } else {
        location.href = path
      }
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(to, from) {
        if (to.path == '/intro') {
          this.intro = true
          this.service = false
        } else if (to.path == '/service') {
          this.intro = false
          this.service = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
#header {
  width: 100%;
  height: 100%;
}
.header-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}
.spacer {
  flex-grow: 1 !important;
}
/* PC */
@media (min-width: 641px) {
  .header {
    position: fixed;
    top: 0;
    left: 0;
    height: 80px;
    width: 100%;
    padding: 0 12%;
    display: flex;
    background: #ffffff;
    z-index: 99999;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .main-logo {
    background: url('/static/img/main_logo.png') no-repeat 100% 100%;
    width: 95px;
    height: 16px;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .icon_menu {
    display: none;
  }
  .close_menu {
    display: none;
  }
  .header-wrap ul {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }
  .header-wrap li {
    margin: 0 30px;
    padding: 28px 0;
    border: 0;
    float: left;
    cursor: pointer;

    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    position: relative;
  }
  .header-wrap li.active {
    margin: 0 30px;
    padding: 28px 0;
    border: 0;
    float: left;
    cursor: pointer;

    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #007def;
    position: relative;
  }
  .header-wrap li:hover {
    margin: 0 30px;
    padding: 28px 0;
    border: 0;
    float: left;
    cursor: pointer;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #007def;
    position: relative;
  }
  .header-wrap li.active .border {
    position: absolute;
    bottom: 0;
    border-bottom: 5px solid;
    height: 100%;
    width: 100%;
  }
  .mobile_menu {
    display: none;
  }
}
/* mobile */
@media (max-width: 640px) {
  .header {
    position: fixed;
    top: 0;
    left: 0;
    height: 60px;
    width: 100%;
    padding: 0 8%;
    display: flex;
    background: #ffffff;
    z-index: 99999;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .main-logo {
    background: url('/static/img/mobile/main_logo_m.png') no-repeat 100% 100%;
    width: 95px;
    height: 16px;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .header-wrap ul {
    display: none;
  }
  .mobile_menu ul {
    margin: 0;
    padding: 0;
    align-items: center;
    display: flex;
    align-content: flex-start;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: auto;
  }
  .mobile_menu li {
    margin: 28px 0;
    padding: 0;
    border: 0;
    cursor: pointer;

    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
    position: relative;
  }
  .mobile_menu li:hover,
  .mobile_menu li:active {
    margin: 28px 0;
    border: 0;
    padding: 0;
    cursor: pointer;

    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
    position: relative;
    border-bottom: 3px solid #007def;
  }
  .icon_menu {
    background: url('/static/img/mobile/btn_menu.png') no-repeat 100% 100%;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .close_menu {
    background: url('/static/img/mobile/btn_close.png') no-repeat 100% 100%;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .mobile_menu {
    display: flex;
    position: fixed;
    left: -100%;
    top: 0;
    width: 100%;
    margin-top: 60px;
    height: 100%;
    z-index: 99999;
    background: #ffffff;
    align-items: center;
    justify-content: center;
    transition: 0.7s;
  }
  .mobile_menu.active {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    margin-top: 60px;
    width: 100%;
    height: 100%;
    z-index: 99999;
    background: #ffffff;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inc/Header.vue